module.exports = __webpack_public_path__ + "img/coin-phone.f45d0c1b.png";